// extracted by mini-css-extract-plugin
export var cardHeader = "_up-0";
export var reorderHandle = "_up-3";
export var titleArea = "_up-1";
export var titleAreaWithHandle = "_up-2";